import { Button } from "react-bulma-components";


import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useUser } from "../../models/user";
import { AppDispatch } from "../../redux/store";
import { showModal } from "../modal/modalSlice";
import { modal } from "../modal/modalTypes";

type LoggedInUserButtonProps = { uid: string }

export const LoggedInUserButton = ({ ...props }: LoggedInUserButtonProps) => {
  const { t, i18n } = useTranslation();
  const [user, loading, error] = useUser(props.uid);

  const dispatch = useDispatch<AppDispatch>()

  if (loading) return <Button color="dark" loading disabled />;
  if (error) return (
    <Button color="dark" disabled>
      <span>{t("error.profileLoadFailed")}</span>
    </Button>
  );

  return (
    <Button color="dark" title={t("tooltip.updateProfile")} loading={loading} disabled={loading}
      onClick={() => user && dispatch(showModal(modal("editProfile", { name: user.name })))}
    >
      <span>
        {t("logged-in-as")}&nbsp;<b>{user ? user.name : t("unknown-user")}</b>
      </span>
    </Button>
  )
}
